import { EventEmitter } from 'events';
import { PlayerDispatcher } from '~/flux/dispatchers';
import ReferralsDispatcher from '~/flux/dispatchers/ReferralsDispatcher';
import { registerDispatchHandlers } from '~/Tools';
import * as handlers from './handlers';
import messages from './messages';

let playerId: string | null = null;

const ReferralsStore = Object.assign({}, EventEmitter.prototype, {
  ...messages,
});
EventEmitter.call(ReferralsStore);
export default ReferralsStore;

const emit = ReferralsStore.emit.bind(ReferralsStore);

PlayerDispatcher.register(
  registerDispatchHandlers({
    [PlayerDispatcher.PLAYER_LOGGED_IN]: (action: { player: { _id: string } }) => {
      playerId = action.player._id;
    },
  })
);

ReferralsDispatcher.register(
  registerDispatchHandlers({
    [ReferralsDispatcher.CLAIM_REFERRAL_CODE]: async (action: { code: string }) => {
      await handlers.claimReferralCode({ playerId, code: action.code, emit });
    },
  })
);
